module.exports = __webpack_public_path__ + "img/trade.982ad64f.png";